class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0,null,null,null,null,this.hasAttribute('data-has-wrapping') ? 'remove': null);
      /**
     * ReSCI tracking
     */
      if(window._check_cart){
        window._check_cart();
      }
    });
    
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    this.cartUpdateUnsubscriber = undefined;
  }

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    this.renderUserCart();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId,
      null,
      null,
      null,
      event.target.dataset.itemProperty
    );
    if(window._check_cart){
      window._check_cart();
    }
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
    if(window._check_cart){
      window._check_cart();
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-item-footer',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-cart-item-footer'
      },
      {
        id: 'cart-total',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.cart_total_box'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'bag-item-count',
        section: document.getElementById('bag-item-count').dataset.id,
        selector: '.js-bag-item-count'
      },
      // { 
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  async updateQuantity(line, quantity, name, variantId, properties = null, modalId = null, wrappingAction = null, propertyData = null) {
    this.enableLoading(line);
    
      if(quantity > 1 && propertyData && propertyData.split(',')){
        let propertyDataArray = propertyData.split(',');
        
        let giftWrap = false;
        let bid = null;
        let pid = null;
        let finalSale = null;
        let sale = null;
        let vendorName = null;

        for (let i = 0; i < propertyDataArray.length; i++) {
          if (propertyDataArray[i].startsWith('_gift_wrap:')) {
            giftWrap = propertyDataArray[i].split(':')[1] === 'true';
          } else if (propertyDataArray[i].startsWith('_bid:')) {
            bid = propertyDataArray[i].split(':')[1];
          } else if (propertyDataArray[i].startsWith('_pid:')) {
            pid = propertyDataArray[i].split(':')[1];
          } else if (propertyDataArray[i].startsWith('_finalSale:')) {
            finalSale = propertyDataArray[i].split(':')[1];
          } else if (propertyDataArray[i].startsWith('_sale:')) {
            sale = propertyDataArray[i].split(':')[1];
          } else if (propertyDataArray[i].startsWith('_vendorName:')) {
            vendorName = propertyDataArray[i].split(':')[1];
          }
        }

        if(giftWrap){
          wrappingAction = 'remove';
        }
        properties = {
          '_bid': bid,
          '_pid': pid,
          '_finalSale': finalSale,
          '_sale': sale,
          '_vendorName': vendorName
        }

        if(finalSale == 'Yes') {
          properties['_LPROP'] = 'final-sale';
        }

      }

    const body = JSON.stringify({
      line,
      quantity,
      properties,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    document.querySelectorAll('[id^=IsGift-template]').forEach((modal) => modal.remove());

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if(wrappingAction){
          let giftReturn = await this.updateGiftWrapper(wrappingAction);
          parsedState.sections = giftReturn.sections;
          parsedState.item_count = giftReturn.item_count;
        }

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        if(modalId){
          document.getElementById(modalId).hide();
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  async updateGiftWrapper(wrappingAction = null){
    //("updateGiftWrapper")
    if(wrappingAction != null && window.giftWrapper != null){
      let wrapperProduct = window.giftWrapper.variants[0].id;
      let fetchCart = await fetch('/cart.json');
      let cartJson = await fetchCart.json();
      let addedWrapperproduct = cartJson.items.filter(item => (item.id == wrapperProduct))[0];
      var formData = new FormData();
      formData.append("sections",this.getSectionsToRender().map((section) => section.section))
      formData.append("sections_url",window.location.pathname)

      const config = window.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if(wrappingAction == "add"){
        if(addedWrapperproduct != undefined){
          formData.append(`updates[${addedWrapperproduct.key}]`,(addedWrapperproduct.quantity + 1));
        }else{
          formData.append('id',wrapperProduct);
          formData.append('quantity',1);

          config.body = formData;

          let responce = await fetch(routes.cart_add_url,config);
          let responceData = responce.json();
          return responceData;
        }
      }else if(wrappingAction == "remove"){
        formData.append(`updates[${addedWrapperproduct.key}]`,(addedWrapperproduct.quantity - 1));
      }
      if(addedWrapperproduct != undefined){
        config.body = formData;
        let responce = await fetch(routes.cart_update_url,config);
        let responceData = responce.json();
        return responceData;
      }
    }
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }

  async renderUserCart(){
    let url = new URL(window.location.href);
    let cid = url.searchParams.get('cid');
    if(cid == "" || cid == null) return;
    this.classList.add('fetching-cart');

    let fetchUserCart = await fetch(`https://wsapi.halsbrook.com/v3prod/shopify/getbag/${cid}`);
    let userCartJson = await fetchUserCart.json();

    await fetch(window.Shopify.routes.root + 'cart/clear.js', {
      method: 'POST'
    });


    let frmData = {
      items: userCartJson.items.reverse().map(item => ({
        id: item.variant_id,
        quantity: item.quantity,
        properties: item.properties
      }))
    };
    
    let addDataResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(frmData)
    })
    let addData = await addDataResponse.json();

    let formData = new FormData();
    for (let key in userCartJson.attributes) {
      if (userCartJson.attributes.hasOwnProperty(key)) {
        formData.append(`attributes[${key}]`, userCartJson.attributes[key]);
      }
    }
    formData.append("note", userCartJson.note);
    formData.append("sections",this.getSectionsToRender().map((section) => section.section))
    formData.append("sections_url",window.location.pathname);

    let updateCart = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      body: formData
    });
    let updateCartResponce = await updateCart.json();

    this.classList.toggle('is-empty', updateCartResponce.item_count === 0);
    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) cartFooter.classList.toggle('is-empty', updateCartResponce.item_count === 0);


    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        updateCartResponce.sections[section.section],
        section.selector
      );
    });

    this.classList.remove('fetching-cart');
    window.history.replaceState({}, '', `/cart`);
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('save-bag')) {
  customElements.define(
    'save-bag',
    class SaveBag extends HTMLElement {
      constructor() {
        super();

        let saveBagBtn = this.querySelector('.js-save-my-bag-btn');
        if(saveBagBtn){
          let customerEmail = this.querySelector('.js-save-my-bag-btn').getAttribute('data-customer-email');
          saveBagBtn.addEventListener('click', this.saveBag.bind(this, customerEmail, saveBagBtn, null));
        }

        let saveBagWithoutEmail =  document.querySelector('.js-save-bag-email');
        if(saveBagWithoutEmail){
          saveBagWithoutEmail.addEventListener('click', this.saveBagWithoutEmail.bind(this));
        }

        let hideBagBtn =  this.querySelector('.js-toggle-bag');
        if(hideBagBtn){
          hideBagBtn.addEventListener('click', function(e){
            e.preventDefault();
            this.closest('.js-show-hide-bag').classList.add('hidden');
          });
        }
      }

      async saveBag(emailValue, saveBagBtn, emailModal) {
        try {
          if(saveBagBtn){
            let saveStatusModalId = saveBagBtn.closest('modal-opener').getAttribute('data-modal');
            saveBagBtn.classList.add('loading')
            saveBagBtn.querySelector('.js-spinner').classList.remove('hidden');
            if(document.querySelector(saveStatusModalId)){
              document.querySelector(saveStatusModalId).hide();
            }
          }

          let response = await fetch(window.Shopify.routes.root + 'cart.js', {
            method: 'GET'
          });
          let cartData = await response.json();
          let customerEmail = emailValue; 

          const config = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              'email': customerEmail,
              'cart': cartData
            })
          };

          let saveResponse = await fetch('https://wsapi.halsbrook.com/shopify/saveMyBag', config);
          let saveResponseData = await saveResponse.json();
          let responseStatus = saveResponse.ok;
          
          if(responseStatus){
            this.closest('.js-show-hide-bag').classList.add('hidden');
            let saveBagButton = this.querySelector('.js-save-my-bag-btn');
            if(emailModal){
              emailModal.hide();
            }
            if(saveBagButton){
              let modalId = saveBagButton.closest('modal-opener').getAttribute('data-modal');
              if(document.querySelector(modalId)){

                let headingText = document.querySelector(modalId).querySelector('.js-popup-heading').innerHTML;
                let parts = customerEmail.split('@');
                let maskedLocalPart = parts[0].charAt(0) + '****';
                let maskedEmail = maskedLocalPart + '@' + parts[1];
                if(headingText){
                  headingText = headingText.replace("[email]", maskedEmail);
                  document.querySelector(modalId).querySelector('.js-popup-heading').innerHTML = headingText
                }

                document.querySelector(modalId).show();
              }
            }
          }
        } catch (error) {
          console.error('Error:', error);
        }
      }

      saveBagWithoutEmail(){
        let modalOpener = this.querySelector('.js-save-bag-modal-opener');
        if(modalOpener){
          let modalAttribute = modalOpener.getAttribute('data-modal');
          let emailModal = document.querySelector(modalAttribute);
          if(emailModal){
            let emailValue = emailModal.querySelector('.js-save-bag-email-field').value;
            let saveEmailBtn = emailModal.querySelector('.js-save-bag-email');
            if(saveEmailBtn){
              saveEmailBtn.classList.add('loading')
              saveEmailBtn.querySelector('.js-spinner').classList.remove('hidden');
            }
        
            function validateEmail(emailValue) {
              const re = /^[^\s@]+@[^\s@]+$/;
              return re.test(emailValue);
            }
    
            if(validateEmail(emailValue)){
              this.saveBag(emailValue, null, emailModal);
            }
            else{
              let bagError = emailModal.querySelector('.js-save-bag-error');
              if(bagError){
                bagError.classList.remove('hidden');
                if(saveEmailBtn){
                  saveEmailBtn.classList.remove('loading')
                  saveEmailBtn.querySelector('.js-spinner').classList.add('hidden');
                }
              }      
            }
          }
        }
      }

    }
  );
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

if (!customElements.get('gift-card')) {
  customElements.define(
    'gift-card',
    class GiftCard extends HTMLElement {
      constructor() {
        super();

        let submitBtn = this.querySelector('.js-gift-submit-btn');
        submitBtn.addEventListener('click', this.handleGiftCardSubmit.bind(this));

        let giftForm = this.getAttribute('data-current-modal');
        let hideGiftForm = this.closest(`#${giftForm}`).querySelector('.js-hide-gift-form');
        let showGiftForm = this.closest(`#${giftForm}`).querySelector('.js-show-gift-form');

        let showGiftImage = this.closest(`#${giftForm}`).querySelector('.js-show-gift-image');
        let hideGiftImage = this.closest(`#${giftForm}`).querySelector('.js-hide-gift-image');
     
        if (showGiftImage) {
          showGiftImage.addEventListener('change', function() {
            let giftImage = this.closest('modal-dialog').querySelector('.js-gift-image');
            if (showGiftImage.checked) {
              giftImage.classList.remove('hidden');
            }
          });
        }

        if (hideGiftImage) {
          hideGiftImage.addEventListener('change', function() {
            let giftImage = this.closest('modal-dialog').querySelector('.js-gift-image');
            if (hideGiftImage.checked) {
              giftImage.classList.add('hidden');
            }
          });
        }

        if (hideGiftForm) {
          hideGiftForm.addEventListener('change', function() {
            let giftCardElement = this.closest('modal-dialog').querySelector('.js-gift-form-content');
            if (hideGiftForm.checked) {
              giftCardElement.classList.add('hidden');
              giftCardElement.querySelector('.js-from-value').value = '';
              giftCardElement.querySelector('.js-to-value').value = '';
              giftCardElement.querySelector('.js-message-value').value = '';
            }
          });
        }

        if (showGiftForm) {
          showGiftForm.addEventListener('change', function() {
            let giftCardElement = this.closest('modal-dialog').querySelector('.js-gift-form-content');
            if (showGiftForm.checked) {
              giftCardElement.classList.remove('hidden');
              // this.closest('modal-dialog').querySelectorAll('.js-gift-form-field').forEach((item) => {
              //   item.removeAttribute('disabled');
              // })
            }
          });
        }

      }

      handleGiftCardSubmit() {

        let formValue = this.querySelector('.js-from-value').value.trim();
        let toValue = this.querySelector('.js-to-value').value.trim();
        let messageValue = this.querySelector('.js-message-value').value.trim();
        let modal = this.closest('modal-dialog');
        let line = modal.getAttribute('data-product-line');
        let quantity = modal.getAttribute('data-product-quantity');
        let variantId = modal.getAttribute('data-giftvariant-id');
        let cartItem = document.querySelector('.js-cart-page');
        let modalId = this.getAttribute('data-current-modal');
        let existingProperty = this.getAttribute('data-existing-properties');
        let isGiftWrap = false;
        if(modal.querySelector('.js-gift-wrap')){
          isGiftWrap = modal.querySelector('.js-gift-wrap').checked;
        }

        if(modal.querySelector('.js-show-gift-form').checked){
          const showError = (selector, condition) => {
            this.querySelector(selector).classList.toggle('hidden', condition);
            return condition;
          };
          
          if (![
              showError('.js-from-error', !!formValue),
              showError('.js-to-error', !!toValue),
              showError('.js-message-error', !!messageValue)
            ].every(Boolean)) return;
        }

        let propertiesObject = existingProperty ? {
          _bid: existingProperty.split(',')[0].split(':')[1],
          _pid: existingProperty.split(',')[1].split(':')[1],
          _finalSale: existingProperty.split(',')[2].split(':')[1],
          _sale: existingProperty.split(',')[3].split(':')[1],
          _vendorName: existingProperty.split(',')[4].split(':')[1],
          "From": formValue,
          "To": toValue,
          "Message": messageValue,
          "_gift_wrap": isGiftWrap
        } : {
          "From": formValue,
          "To": toValue,
          "Message": messageValue,
          "_gift_wrap": isGiftWrap
        };

        if(existingProperty && propertiesObject._finalSale == 'Yes') {
          propertiesObject['_LPROP'] = 'final-sale';
        }

        let addGiftWrapper = isGiftWrap ? 'add'  : '' ;

        if((formValue != "" && toValue != "" && messageValue != "") || isGiftWrap == true){
          cartItem.updateQuantity(line, quantity, '', variantId, propertiesObject, modalId, addGiftWrapper, existingProperty);
        }
        else{
          modal.hide();
        }

      }
    }
  );
}

if (!customElements.get('clear-gift-properties')) {
  customElements.define(
    'clear-gift-properties',
    class ClearGiftProperties extends HTMLElement {
      constructor() {
        super();

        let clearBtn = this.querySelector('.js-clear-properties-btn');
        clearBtn.addEventListener('click', this.handleGiftCardClear.bind(this));
      }

      handleGiftCardClear() {
      
        let line = this.getAttribute('data-gift-property-line');
        let quantity = this.getAttribute('data-gift-property-quantity');
        let variantId = this.getAttribute('data-gift-property-id');
        let cartItem = document.querySelector('.js-cart-page');
        let dataExistingProperty = this.getAttribute('data-exist-properties');
        let isGiftWrap = this.querySelector('.js-clear-properties-btn').getAttribute('data-gift-wrap-property');

        let removeGiftWrapper = isGiftWrap == 'true' ? 'remove' : '';
        
        let propertiesObject = dataExistingProperty ? {
          _bid: dataExistingProperty.split(',')[0].split(':')[1],
          _pid: dataExistingProperty.split(',')[1].split(':')[1],
          _finalSale: dataExistingProperty.split(',')[2].split(':')[1],
          _sale: dataExistingProperty.split(',')[3].split(':')[1],
          _vendorName: dataExistingProperty.split(',')[4].split(':')[1]
        } : {};

        if(dataExistingProperty && propertiesObject._finalSale == 'Yes') {
          propertiesObject['_LPROP'] = 'final-sale';
        }

        cartItem.updateQuantity(line, quantity, '', variantId, propertiesObject,null,removeGiftWrapper);
      }

    }
  );
}